'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var parseStringBoolean = exports.parseStringBoolean = function parseStringBoolean(stringBoolean) {
  if (stringBoolean === 'true') {
    return true;
  }

  if (stringBoolean === 'false') {
    return false;
  }

  return undefined;
};